import { NgModule, ErrorHandler, inject } from '@angular/core';
import { SlackTransporterFactory, AdminLoggerFactory } from './transporters/Configurations';
import { LogLevel } from './models/LogLevel';
import { CustomErrorHandler } from './CustomErrorHandler';
import { LoggerService } from './logger.service';
import { HttpClient } from '@angular/common/http';
import { SlackNotificationService } from '../../services/slack-notification.service';
import { ILoggerConfiguration } from './models/ILoggerConfiguration';
import {
    ADMIN_LOGGER_TOKEN,
    LOGGER_CONFIGURATION_TOKEN,
    LOGGER_TOKEN,
    TRANSPORTER_TOKEN,
    WEBHOOK_URL_KEY
} from './InjectionTokens';

@NgModule({
    providers: [
        {
            // used to pass any external information that logger might need
            // to work (urls, tokens, etc, so far only level we are providing)
            provide: LOGGER_CONFIGURATION_TOKEN,
            useValue: { level: LogLevel.Info }
        },
        {
            // Here we provide our logger by default if logger module is imported.
            // and that's it, transporters and template are the ones whe will be
            // provided entirely by external source (in case you wrap this in a library)
            // we leave open that door but we set the rules with the interfaces.
            provide: LOGGER_TOKEN,
            useClass: LoggerService
        },
        // Override default angular error handler with ours
        { provide: ErrorHandler, useClass: CustomErrorHandler },

        // providing as many transporter as needed
        // { provide: TransporterToken, useFactory: MyConsoleTransporterFactory, multi: true },
        // {
        //     // provide Http Transporter
        //     provide: TransporterToken,
        //     useFactory: MyHttpTransporterFactory,
        //     multi: true,
        //     deps: [HttpClient]
        // },
        {
            // provide Slack Transporter
            provide: TRANSPORTER_TOKEN,
            useFactory: SlackTransporterFactory,
            multi: true,
            deps: [HttpClient, SlackNotificationService]
        },
        {
            provide: WEBHOOK_URL_KEY,
            useValue: 'SlackWebHookUrl'
        },
        {
            provide: ADMIN_LOGGER_TOKEN,
            useFactory: AdminLoggerFactory,
            deps: [HttpClient]
        }
    ]
})
export class LoggerModule {}
